import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import nlTranslation from './locales/nl/translation.json';
import enTranslation from './locales/en/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nlTranslation },
      en: { translation: enTranslation },
    },
    fallbackLng: 'nl',
    supportedLngs: ['nl', 'en'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'vbcontrol-language',
      caches: ['localStorage'],
    },
  });

export default i18n;
